/**
 * 数字辅助工具类
 */
let numUl = {
  /**
   * 是否是整数
   * @param obj
   * @returns {boolean}
   */
  isInteger: function (obj) {
    return typeof obj === 'number' && obj % 1 === 0
  },
  toThousands: function (num) {
    // 如果是小数
    let nums = num, decimal = '', result = ''
    if (num.toString().indexOf('.') !== -1) {
      nums = num.toFixed(2)
    }
    nums = (nums || 0).toString().split('.')
    // eslint-disable-next-line no-prototype-builtins
    if (nums.hasOwnProperty(1)) {
      decimal = nums[1]
    }
    nums = nums[0]
    while (nums.length > 3) {
      result = ',' + nums.slice(-3) + result
      nums = nums.slice(0, nums.length - 3)
    }
    if (nums) {
      result = nums + result
    }
    if (decimal !== '') {
      result = result + '.' + decimal
    }
    return result
  },
  toPercent (num) {
    if (num !== undefined && num !== '') {
      if (num === 0) return 0
      return parseFloat((num * 100).toFixed(2)) + '%'
    }
    return '---'
  },
  toPercentUpDown (num) {
    if (num !== undefined && num !== '') {
      if (num === 0) return 0
      if (num > 0) return ' ↑ ' + parseFloat((num * 100).toFixed(2)) + '%'
      return ' ↓' + parseFloat((num * 100).toFixed(2)) + '%'
    }
    return '---'
  },
    /**
     * 保留小数位
     * @param num
     * @param figuresKeep  要保留的小数位
     * @returns {*}
     */
  keepFigures (num, figuresKeep) {
    if (num !== undefined && num !== null && num !== '') {
      if (num === 0) return 0
      return parseFloat(num.toFixed(figuresKeep))
    }
  },
    /**
     * 对小数进行处理，保留指定位数，是否加'%'
     * @param num
     * @param figuresKeep
     * @param hasPercent
     * @returns {string}
     */
  toPercentWithFigures (num, figuresKeep, hasPercent) {
    let sign = ''
    if (hasPercent) {
      sign = '%'
    }
    if (num !== undefined && num !== '') {
      return (num * 100).toFixed(figuresKeep) + sign
    }
  },

  toKMB (val) {
    let digits = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2

    if (isNaN(+val)) return val

    let symbolMap = [{value: 1E18, symbol: 'E'}, {value: 1E15, symbol: 'P'}, {value: 1E12, symbol: 'T'}, {
      value: 1E9,
      symbol: 'B'
    }, {value: 1E6, symbol: 'M'}, {value: 1E3, symbol: 'k'}]

    for (let i = 0; i < symbolMap.length; i++) {
      if (Math.abs(val) >= symbolMap[i].value) {
        return (val / symbolMap[i].value).toFixed(digits) + symbolMap[i].symbol
      }
    }

    return val.toString()
  }
}

export default numUl
